import BasePropertyView from 'BasePropertyView.js';
import Template from 'behaviors/properties/main/function.ejs';
import widgetUtil   from 'util/WidgetUtil.js';
import constants    from 'Constants.js';
import utils        from 'util/Util.js'
import eventBus from 'EventBus.js';
//=====================================================================
//
// An instance of this view represents a function.
//
// Casey Justus, April 25, 2016
//
//=====================================================================

class MainFunctionView extends BasePropertyView {

    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el; 

        this.events = {
            'change input[type=text]'   : 'updateAttributes',
            'blur input[type=text]'     : 'lostFocus',
            'focus input[type=text]'    : 'getFocus'
        }; 

        this.listenTo(this.model, 'change', this.render);

        if (!utils.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, utils.resizeGridWidth);
        }

        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propVal  = utils.sanitizeHTML(ev.currentTarget.value, true, 'function');
        this.model.set( 'function', propVal );
        this.model.set('widgetText', widgetUtil.getWidgetText(this.model) ) ;
    }



    render() {

        if(this.template) {
            this.$el.html(this.template({functionName: this.model.get('function')}));
        }
        
        this.delegateEvents();
        return this;
    }

}

export default MainFunctionView;
